import React, { forwardRef } from 'react';
import './matchMedia';
import Slider from 'react-slick';

const Carousel = forwardRef((props, ref) => {
  return (
    <Slider ref={ref} {...props}>
      {props.children}
    </Slider>
  );
});

export default Carousel;
